module.exports = __webpack_public_path__ + "img/Ryoko82.29ff004c.jpg";